import callAPiBase from './base';

const transportCardsPlaceApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/transportCardPlaceList',
      method: 'GET',
      useToken: true,
      title: 'Transport Cards Place - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardPlaceCreate',
      method: 'POST',
      useToken: true,
      title: 'Transport Cards Place - Create Place',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardPlaceUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Transport Cards Place - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/transportCardPlaceDelete`,
      method: 'DELETE',
      useToken: true,
      title: 'Transport Cards Place - Delete',
      params,
    }),
};

export { transportCardsPlaceApi };
export default transportCardsPlaceApi;
